import { Checkbox, TableCell } from '@mui/material'
import type { FC } from 'react'
import type { TChooseScheduleUUIDsState } from './ScheduleListContent'
import type { TBaseColumnProps } from './ScheduleListRow'

const CheckboxRow: FC<TBaseColumnProps<TChooseScheduleUUIDsState>> = ({
  schedule: { uuid },
  chooseScheduleUUIDsState,
}) => {
  const [chooseScheduleUUIDs, setChooseScheduleUUIDs] = chooseScheduleUUIDsState

  const handleCheckSchedule = (scheduleUUID: string, checked: boolean) => {
    if (checked) {
      setChooseScheduleUUIDs([...chooseScheduleUUIDs, scheduleUUID])
    } else {
      setChooseScheduleUUIDs(
        chooseScheduleUUIDs.filter((uuid: string) => uuid !== scheduleUUID),
      )
    }
  }

  return (
    <TableCell padding="checkbox">
      <Checkbox
        checked={uuid ? chooseScheduleUUIDs.some(v => v === uuid) : false}
        onChange={e => uuid && handleCheckSchedule(uuid, e.target.checked)}
        onClick={e => e.stopPropagation()}
      />
    </TableCell>
  )
}

export default CheckboxRow
